import { Place, PlaceService, PlaceServiceGroup } from '@/types/state/shared';
import { omit } from '@/helpers';
import { Review } from '@/types/reviews';

// NOTE. Lightweight inspiration by https://www.npmjs.com/package/normalizr
export function normalizr(inputArray: any[]): { ids: Array<number | string>; all: Record<string, any> } {
  if (Array.isArray(inputArray) && inputArray.length > 0) {
    const ids: Array<number | string> = [];
    const all: Record<string, any> = {};

    for (const item of inputArray) {
      if (item && typeof item === 'object' && 'id' in item) {
        ids.push(item.id);
        all[item.id] = item;
      }
    }

    return { ids, all };
  }

  return { ids: [], all: {} };
}

export const normalizeServiceCategories = (serviceCategories: Array<PlaceServiceGroup>) => {
  return normalizr(
    serviceCategories.map((serviceCategory) => ({
      ...serviceCategory,
      services: serviceCategory.services.map((service: PlaceService) => service.id),
    })),
  );
};

export const normalizePlace = (place: Place) => {
  const flattenedServices = place.services.reduce((acc, service) => {
    return [...acc, ...service.services];
  }, []);

  return {
    ...place,
    employees: place.employees.map((employee) => employee.id),
    servicesCategories: place.services.map((service) => service.id),
    services: flattenedServices.map((service) => service.id),
  };
};

export const normalizePlacePageData = (place: Place) => {
  const flattenedServices = place.services.reduce((acc, service) => {
    return [...acc, ...service.services];
  }, []);

  const cleanPlace = omit(place, ['bookingBundles']);

  const normalizedPlace = normalizePlace(cleanPlace);
  const normalizedServiceCategories = normalizeServiceCategories(cleanPlace.services);
  const normalizedServices = normalizr(flattenedServices);
  const normalizedEmployees = normalizr(cleanPlace.employees);

  return { normalizedPlace, normalizedServiceCategories, normalizedServices, normalizedEmployees };
};

export const normalizeReviewListItems = (reviewList: Array<Review>) => {
  return normalizr(reviewList);
};
